/*重构的模型训练的接口功能*/
import axios from '../index'

import api from './RecycleBin.api'


export default {
    /**
     * 获取回收站文件类型 @data dictTypeCode:RecycleType
     */
    getComDictionary(data) {
        return axios({
            url: api.getComDictionary,
            method: 'post',
            data: data,
        })
    },
    /**
     * 查询回收站首页列表数据 @data name 名称； recycleType userId pageNum pageSize
     */
    getRecycleList(data) {
        return axios({
            url: api.getRecycleList,
            method: 'post',
            data: data,
        })
    },

    /**
     * 恢复回收站列表数据 @data onlyId 唯一id; recycleType 文件类型
     */
    recoveryRecycleData(data) {
        return axios({
            url: api.recoveryRecycleData,
            method: 'post',
            data: data,
        })
    },
    /**
     * 解决重名冲突 @data name 文件名称； onlyId 唯一id; recycleType 文件类型 solveType 解决类型：1：替换目标中的文件；2：跳过该文件（将还原的文件自动加一个后缀编号，如X-恢复）
     */
    solveDoubleName(data) {
        return axios({
            url: api.solveDoubleName,
            method: 'post',
            data: data,
        })
    },
    /**
     * 彻底删除回收站数据 @data  onlyId 唯一id; recycleType 文件类型
     */
    deleteRecycleData(data) {
        return axios({
            url: api.deleteRecycleData,
            method: 'post',
            data: data,
        })
    },
}
